'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import Link from 'next/link';
import PropTypes from 'prop-types';

import ButtonCTA from 'components/ui/ButtonCTA';
import Carousel from 'components/ui/Carousel';
import Img from 'components/ui/Img';
import Text from 'components/ui/Text';

import styles from './Products.module.scss';

const Hero = ({ productNavigation }) => {
    return (
        <div className={styles.hero}>
            <div className={styles.inner}>
                <div className={styles.headingGroup}>
                    <Text
                        baseTheme="displayLarge"
                        themes={{
                            large: 'displayXLarge',
                            xxLarge: 'displayXXLarge',
                        }}
                        as="h2"
                        className={styles.title}
                    >
                        Made to make
                        <br /> your day.
                    </Text>
                    <ButtonCTA
                        iconType="location"
                        text={'Where to Buy'}
                        style="filled-blue-cream"
                        link={{
                            slug: 'where-to-buy',
                        }}
                    />
                </div>
            </div>

            <div className={styles.sliderSection}>
                <Carousel
                    className={styles.sliderWrapper}
                    containerClassName={styles.slider}
                    slideClassName={styles.slide}
                    autoScroll={false}
                    hideScrollBars
                >
                    {productNavigation.navItemsCollection.items.map(
                        (item, i) => {
                            return (
                                <Link
                                    key={i}
                                    href={`/products/${item.slug}`}
                                    className={styles.item}
                                >
                                    <Img
                                        className={styles.productImage}
                                        src={item?.thumbnail?.url}
                                        fallbackImageWidth={120}
                                        alt={item.title}
                                        width={item?.thumbnail?.width}
                                        height={item?.thumbnail?.height}
                                        customSources={[
                                            {
                                                breakpoint: 1024,
                                                src: item?.thumbnail?.url,
                                                imageWidth: 285,
                                            },
                                            {
                                                breakpoint: 768,
                                                src: item?.thumbnail?.url,
                                                imageWidth: 235,
                                            },
                                            {
                                                src: item?.thumbnail?.url,
                                                imageWidth: 120,
                                            },
                                        ]}
                                        priority
                                    />
                                    <Text
                                        as="span"
                                        className={styles.productName}
                                        baseTheme="bodyXSmall"
                                        themes={{ medium: 'bodyLarge' }}
                                    >
                                        {item.title}
                                    </Text>
                                </Link>
                            );
                        }
                    )}
                </Carousel>
            </div>
        </div>
    );
};

Hero.propTypes = {
    productNavigation: PropTypes.shape({
        navItemsCollection: PropTypes.shape({
            items: PropTypes.array.isRequired,
        }),
    }),
};

export default Hero;
